<div style="display: flex; overflow: auto; height: 100%;">
  <div style="display: flex; flex-direction: column; width: 100%;">
    <div style="display: flex; flex-direction: column; padding: 20px; z-index: 1; height: 100%;">
      <mat-toolbar color="primary" class="toolbar-over-card"
                   style="padding: 20px; align-items: center; justify-content: space-between;">
        <div><span>AI Review Insights</span></div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="height: auto;">
        <mat-card-content style="min-height: 250px;">
          <mat-form-field style="font-size: 14px; width:30%; height: auto;">
            <mat-label>--- Select Result Field ---</mat-label>
            <mat-select [(value)]="selectedCodingFieldId" (selectionChange)="selectCodingFieldChange()">
              <mat-optgroup *ngFor="let group of codingFieldGroups" [label]="group.displayTitle">
                <mat-option *ngFor="let field of group.fields" [value]="field.fieldId">
                  {{field.displayTitle}}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
          <div *ngIf="!selectedCodingFieldId" style="justify-content: center; display: flex; align-items: center; height: 80%; font-size: 16px;">
            <div class="fal fa-file-chart-column" style="padding-right: 8px;"></div>
            Select a field to get started.
          </div>
          <mat-progress-bar mode="determinate" [value]="progress" *ngIf="isLoading"></mat-progress-bar>
          <div *ngIf="selectedCodingFieldId && !isLoading" style="padding-bottom: 20px;">
            <div class="grid">
              <mat-card appearance="outlined" class="inner-card">
                <mat-card-header style="padding-bottom: 10px;">
                  <mat-card-title class="inner-card-title">Actual vs Predicted</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div style="height: 100%;">
                    <ngx-charts-bar-vertical-2d [legend]="true"
                                                [legendPosition]="'right'"
                                                [legendTitle]="''"
                                                [scheme]="actualVsPredictedColorScheme"
                                                [showXAxisLabel]="false"
                                                [showYAxisLabel]="false"
                                                [xAxis]="true"
                                                [yAxis]="true"
                                                [xAxisLabel]=""
                                                [yAxisLabel]=""
                                                [results]="actualVsPredictedChartData"
                                                (select)="selectActualOrPredictedDocuments($event)">
                    </ngx-charts-bar-vertical-2d>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card appearance="outlined" class="inner-card">
                <mat-card-header style="padding-bottom: 10px;">
                  <mat-card-title class="inner-card-title">Confidence of Predictions</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div style="height: 100%;">
                    <ngx-charts-bar-vertical-2d [legend]="true"
                                                [legendPosition]="'right'"
                                                [legendTitle]="''"
                                                [showXAxisLabel]="true"
                                                [showYAxisLabel]="false"
                                                [xAxis]="true"
                                                [yAxis]="true"
                                                [xAxisLabel]="'Confidence'"
                                                [yAxisLabel]=""
                                                [groupPadding]="4"
                                                [barPadding]="2"
                                                [results]="confidenceOfPredictionsChartData"
                                                (select)="selectConfidenceOfPredictionsDocuments($event)">
                    </ngx-charts-bar-vertical-2d>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card appearance="outlined" class="inner-card">
                <mat-card-header style="padding-bottom: 10px;">
                  <mat-card-title class="inner-card-title">AI Precision and Recall</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div style="display: flex; flex-direction: row; height: 100%;">
                    <div class="pie-chart" style="height: 100%">
                      <ngx-charts-pie-chart [results]="precisionPercentageChartData"
                                            [scheme]="precisionGraphColorScheme"
                                            [arcWidth]="0.15"
                                            [doughnut]="true"
                                            [tooltipDisabled]="true">
                      </ngx-charts-pie-chart>
                      <div class="pie-chart-center-text">
                        <div>
                          {{ precisionPercentage | number : '1.0-1' }}%
                        </div>
                        <div>
                          Precision
                        </div>
                      </div>
                    </div>
                    <div class="pie-chart" style="height: 100%">
                      <ngx-charts-pie-chart [results]="recallPercentageChartData"
                                            [scheme]="recallGraphColorScheme"
                                            [arcWidth]="0.15"
                                            [doughnut]="true"
                                            [tooltipDisabled]="true">
                      </ngx-charts-pie-chart>
                      <div class="pie-chart-center-text">
                        <div>
                          {{ recallPercentage | number : '1.0-1' }}%
                        </div>
                        <div>
                          Recall
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card appearance="outlined" class="inner-card">
                <mat-card-title>
                </mat-card-title>
                <mat-card-content>
                  <h4 class="inner-card-title" style="padding-top: 8px; margin-left: 16px;">Total Document Count: <span>{{totalDocCount}}</span></h4>
                  <table class="table-for-graph">
                    <tr>
                      <td class="header">Human Marked As Responsive</td>
                      <td class="value">
                        <a *ngIf="markedAsResponsiveHuman.length > 0" style="cursor:pointer" (click)="goToDocViewer(markedAsResponsiveHuman)">{{markedAsResponsiveHuman.length}}</a>
                        <span *ngIf="markedAsResponsiveHuman.length === 0">0</span>
                      </td>
                      <td class="header">AI Predicted</td>
                      <td class="value">
                        <a *ngIf="markedAsResponsiveAI.length > 0" style="cursor:pointer" (click)="goToDocViewer(markedAsResponsiveAI)">{{markedAsResponsiveAI.length}}</a>
                        <span *ngIf="markedAsResponsiveAI.length === 0">0</span>
                      </td>
                      <td class="header">False Positive</td>
                      <td class="value">
                        <a *ngIf="falsePositive.length > 0" style="cursor:pointer" (click)="goToDocViewer(falsePositive)">{{falsePositive.length}}</a>
                        <span *ngIf="falsePositive.length === 0">0</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="header">Human Marked As Non-responsive</td>
                      <td class="value">
                        <a *ngIf="markedAsNonResponsiveHuman.length > 0" style="cursor:pointer" (click)="goToDocViewer(markedAsNonResponsiveHuman)">{{markedAsNonResponsiveHuman.length}}</a>
                        <span *ngIf="markedAsNonResponsiveHuman.length === 0">0</span>
                      </td>
                      <td class="header">AI Predicted</td>
                      <td class="value">
                        <a *ngIf="markedAsNonResponsiveAI.length > 0" style="cursor:pointer" (click)="goToDocViewer(markedAsNonResponsiveAI)">{{markedAsNonResponsiveAI.length}}</a>
                        <span *ngIf="markedAsNonResponsiveAI.length === 0">0</span>
                      </td>
                      <td class="header">False Negative</td>
                      <td class="value">
                        <a *ngIf="falseNegative.length > 0" style="cursor:pointer" (click)="goToDocViewer(falseNegative)">{{falseNegative.length}}</a>
                        <span *ngIf="falseNegative.length === 0">0</span>
                      </td>
                    </tr>
                  </table>
                  <div class="info-text" style="margin: 16px; font-weight: 600;">
                    Documents that were not reviewed by a Human:
                    <a *ngIf="notCodedHuman.length > 0" style="cursor:pointer" (click)="goToDocViewer(notCodedHuman)">{{notCodedHuman.length}}</a>
                    <span *ngIf="notCodedHuman.length === 0">0</span>
                  </div>
                  <div class="info-text" style="margin: 16px; font-weight: 600;">
                    Documents that were not reviewed by AI:
                    <a *ngIf="notCodedAI.length > 0" style="cursor:pointer" (click)="goToDocViewer(notCodedAI)">{{notCodedAI.length}}</a>
                    <span *ngIf="notCodedAI.length === 0">0</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          </mat-card-content>
        </mat-card>
    </div>
  </div>
</div>
<input #focusFix style="opacity: 0; width: 0px; height: 0px;"/>
